import Icon from '../components/Icon.vue'

Icon.register({
  mask: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M320.7 64C-121.9 64-36.9 448 162.2 448 202.1 448 239.7 427.3 263.6 392.1L289.4 354.4C305 331.4 336.3 331.4 352 354.4L377.7 392.1C401.7 427.3 439.2 448 479.1 448 669 448 769.8 64 320.7 64zM184 308.4C142.9 308.4 116.2 282.7 103.9 267.3 98.7 260.8 98.7 251.2 103.9 244.7 116.2 229.3 142.9 203.6 184 203.6S251.8 229.3 264.1 244.7C269.3 251.2 269.3 260.8 264.1 267.3 251.8 282.7 225.1 308.4 184 308.4zM456 308.4C414.9 308.4 388.2 282.7 375.9 267.3 370.7 260.8 370.7 251.2 375.9 244.7 388.2 229.3 414.9 203.6 456 203.6S523.8 229.3 536.1 244.7C541.3 251.2 541.3 260.8 536.1 267.3 523.8 282.7 497.1 308.4 456 308.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mask.js
// module id = ksCt
// module chunks = 144